const cities = ['אום אל פחם',
        'אופקים',
        'אור יהודה',
        'אור עקיבא',
        'אילת',
        'אלעד',
        'אריאל',
        'אשדוד',
        'אשקלון',
        'באר שבע',
        'בית שאן',
        'בית שמש',
        'ביתר עילית',
        'בני ברק',
        'בת ים',
        'גבעתיים',
        'דימונה',
        'הוד השרון',
        'הרצליה',
        'חדרה',
        'חולון',
        'חיפה',
        'טבריה',
        'טייבה',
        'טירה',
        'טירת הכרמל',
        'טמרה',
        'יבנה',
        'יהוד',
        'ירוחם',
        'ירושלים',
        'כפר סבא',
        'כפר קאסם',
        'כרמיאל',
        'לוד',
        'מגדל העמק',
        'מכבים רעות',
        'מודיעין עילית',
        'מעלה אדומים',
        'מעלות תרחישא',
        'נהריה',
        'נס ציונה',
        'נצרת',
        'נצרת עילית',
        'נשר',
        'נתיבות',
        'נתניה',
        "סח'נין",
        'עכו',
        'עפולה',
        'ערד',
        'פתח תקווה',
        'צפת',
        'קלנסווה',
        'קריית אונו',
        'קריית אתא',
        'קריית ביאליק',
        'קריית גת',
        'קריית ים',
        'קריית מוצקין',
        'קריית מלאכי',
        'קריית שמונה',
        'ראש העין',
        'ראשון לציון',
        'רהט',
        'רחובות',
        'רמלה',
        'רמת גן',
        'רמת השרון',
        'רעננה',
        'שדרות',
        'שפרעם',
        'תל אביב יפו'
    ];

    export default cities;